import React, { useState } from 'react';
import {
  Button,
  Modal,
  Dialog,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
  SimpleTooltip,
} from '@/components/ui';
import { Info } from 'lucide-react';
import { CodeBlock } from '../CodeBlock';
import { SectionWrapper } from '../SectionWrapper';

export function OverlaysSection() {
  const [modalOpen, setModalOpen] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);

  return (
    <SectionWrapper title="Overlays">
        {/* Modal & Dialog */}
        <div>
          <h3 className="text-lg font-semibold mb-4">Modal & Dialog</h3>
          <div className="flex gap-3">
            <Button onClick={() => setModalOpen(true)}>Open Modal</Button>
            <Button variant="danger" onClick={() => setDialogOpen(true)}>Open Dialog</Button>
          </div>

          <Modal
            isOpen={modalOpen}
            onClose={() => setModalOpen(false)}
            title="Modal Title"
            description="This is a modal description that provides context."
          >
            <div className="space-y-4">
              <p>Modal content goes here. You can put any content inside.</p>
              <div className="flex justify-end gap-2">
                <Button variant="ghost" onClick={() => setModalOpen(false)}>
                  Cancel
                </Button>
                <Button variant="primary" onClick={() => setModalOpen(false)}>
                  Save Changes
                </Button>
              </div>
            </div>
          </Modal>

          <Dialog
            isOpen={dialogOpen}
            onClose={() => setDialogOpen(false)}
            onConfirm={() => {
              // TODO: Handle confirmation
              setDialogOpen(false);
            }}
            title="Confirm Action"
            description="Are you sure you want to proceed? This action cannot be undone."
            confirmText="Delete"
            confirmVariant="danger"
          />

          <CodeBlock>
{`// Modal
<Modal
  isOpen={modalOpen}
  onClose={() => setModalOpen(false)}
  title="Modal Title"
  description="This is a modal description."
>
  <div>Modal content goes here.</div>
</Modal>

// Confirmation Dialog
<Dialog
  isOpen={dialogOpen}
  onClose={() => setDialogOpen(false)}
  onConfirm={() => handleDelete()}
  title="Confirm Action"
  description="Are you sure you want to proceed?"
  confirmText="Delete"
  confirmVariant="danger"
/>`}
          </CodeBlock>
        </div>

        {/* Dropdown & Tooltip */}
        <div>
          <h3 className="text-lg font-semibold mb-4">Dropdown & Tooltip</h3>
          <div className="flex items-center gap-4">
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <Button variant="outline">Options</Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent>
                <DropdownMenuLabel>Actions</DropdownMenuLabel>
                <DropdownMenuSeparator />
                <DropdownMenuItem onClick={() => {/* TODO: Handle edit */}}>
                  Edit
                </DropdownMenuItem>
                <DropdownMenuItem onClick={() => {/* TODO: Handle duplicate */}}>
                  Duplicate
                </DropdownMenuItem>
                <DropdownMenuItem onClick={() => {/* TODO: Handle share */}}>
                  Share
                </DropdownMenuItem>
                <DropdownMenuSeparator />
                <DropdownMenuItem onClick={() => {/* TODO: Handle delete */}} className="text-destructive">
                  Delete
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>

            <SimpleTooltip content="This is a helpful tooltip">
              <Button variant="ghost" size="icon">
                <Info className="w-4 h-4" />
              </Button>
            </SimpleTooltip>

            <SimpleTooltip content="Another tooltip example">
              <span className="text-muted-foreground cursor-help">Hover me</span>
            </SimpleTooltip>
          </div>
          <CodeBlock>
{`// Dropdown Menu
<DropdownMenu>
  <DropdownMenuTrigger asChild>
    <Button variant="outline">Options</Button>
  </DropdownMenuTrigger>
  <DropdownMenuContent>
    <DropdownMenuItem onClick={() => {/* TODO: Handle edit */}}>
      Edit
    </DropdownMenuItem>
    <DropdownMenuItem onClick={() => {/* TODO: Handle share */}}>
      Share
    </DropdownMenuItem>
    <DropdownMenuSeparator />
    <DropdownMenuItem onClick={() => {/* TODO: Handle delete */}}>
      Delete
    </DropdownMenuItem>
  </DropdownMenuContent>
</DropdownMenu>

// Tooltip
<SimpleTooltip content="This is a helpful tooltip">
  <Button variant="ghost" size="icon">?</Button>
</SimpleTooltip>`}
          </CodeBlock>
        </div>
    </SectionWrapper>
  );
}
